<template>
  <div class="login">
  </div>
</template>

<script>
let Time
export default {
  name: 'login',
  data () {
    return {
      verifyCode: '',
      canPost: false,
      userId: 0,
      from: this.$route.query.from,
      code: this.$route.query.code,
      forgetEmail: '',
      password: {
        oripassword: '',
        conformPassword: ''
      },
      loginPostData: {
        email: ''
        // password: ''
      },
      forgetStep: 1,
      forgetPasswordFlag: false,
      showGreen: false
    }
  },
  computed: {
  },
  destroyed () {
    clearInterval(Time)
  },
  created () {
    this.getCateList()
    window.location.href = process.env.config.baseUrl + '/saml/login'
    
  },
  mounted () {
  },
  methods: {
    getCateList () {
      this.$axiox.get('/api/product/cateGory/query').then(p => {
        window.localStorage.setItem('canEditList', JSON.stringify(p))
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue